export default __webpack_public_path__ + "static/article-best-food-wine-festivals-Australia-2019-17f7f4cff746b821d85e21e25f3bbf82.jpg";